import React from 'react';
import Icon from '../../../components/AppIcon';

const ProfileHero = ({ professional, onContact, onBook }) => {
  const categoryColors = {
    lawyer: { bg: 'rgba(123,47,255,0.15)', border: 'rgba(123,47,255,0.4)', text: '#A78BFA', icon: 'Scale' },
    photographer: { bg: 'rgba(0,212,255,0.15)', border: 'rgba(0,212,255,0.4)', text: '#00D4FF', icon: 'Camera' },
    stylist: { bg: 'rgba(255,107,157,0.15)', border: 'rgba(255,107,157,0.4)', text: '#FF6B9D', icon: 'Palette' },
  };
  const colors = categoryColors?.[professional?.category] || categoryColors?.lawyer;

  const renderStars = (rating) =>
    Array.from({ length: 5 }, (_, i) => (
      <span key={i} style={{ color: i < Math.floor(rating) ? '#FFD700' : 'rgba(255,215,0,0.3)', fontSize: '18px' }}>★</span>
    ));

  return (
    <div className="rounded-2xl p-6 md:p-8" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(0,212,255,0.15)' }}>
      <div className="flex flex-col md:flex-row gap-6">
        <div
          className="w-24 h-24 md:w-32 md:h-32 rounded-2xl flex items-center justify-center text-4xl font-bold flex-shrink-0"
          style={{ background: colors?.bg, border: `2px solid ${colors?.border}`, color: colors?.text }}
        >
          {professional?.avatar
            ? <img src={professional?.avatar} alt={`${professional?.name} professional headshot`} className="w-full h-full rounded-2xl object-cover" />
            : professional?.name?.charAt(0)?.toUpperCase()
          }
        </div>

        <div className="flex-1">
          <div className="flex flex-wrap items-center gap-3 mb-1">
            <h1 className="text-2xl md:text-3xl font-bold text-white">{professional?.name}</h1>
            {professional?.verified && (
              <span className="flex items-center gap-1 px-3 py-1 rounded-full text-xs font-semibold" style={{ background: 'rgba(0,212,255,0.15)', color: '#00D4FF', border: '1px solid rgba(0,212,255,0.3)' }}>
                <Icon name="BadgeCheck" size={12} /> Verified
              </span>
            )}
            <span className="px-3 py-1 rounded-full text-xs font-semibold" style={{ background: colors?.bg, color: colors?.text, border: `1px solid ${colors?.border}` }}>
              {professional?.categoryLabel}
            </span>
          </div>
          <p className="text-base mb-1" style={{ color: '#A0B4C8' }}>{professional?.company}</p>
          <div className="flex items-center gap-1 mb-3">
            <Icon name="MapPin" size={14} color="#6B9EC4" />
            <span className="text-sm" style={{ color: '#6B9EC4' }}>{professional?.location}</span>
          </div>
          <div className="flex items-center gap-3 mb-4">
            <div className="flex">{renderStars(professional?.rating)}</div>
            <span className="font-bold text-white">{professional?.rating?.toFixed(1)}</span>
            <span className="text-sm" style={{ color: '#6B9EC4' }}>({professional?.reviewCount} reviews)</span>
          </div>

          <div className="flex flex-wrap gap-4 mb-5">
            {[
              { icon: 'CheckCircle', label: 'Jobs Done', value: professional?.completedJobs },
              { icon: 'RefreshCw', label: 'Repeat Clients', value: professional?.repeatClients },
              { icon: 'Clock', label: 'Response Time', value: professional?.responseTime },
              { icon: 'Calendar', label: 'Availability', value: professional?.availability },
            ]?.map((stat) => (
              <div key={stat?.label} className="flex items-center gap-2">
                <Icon name={stat?.icon} size={14} color="#00D4FF" />
                <div>
                  <p className="text-xs" style={{ color: '#6B9EC4' }}>{stat?.label}</p>
                  <p className="text-sm font-semibold text-white">{stat?.value}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="flex flex-wrap gap-3">
            <button
              onClick={onBook}
              className="px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200"
              style={{ background: 'linear-gradient(135deg, #00D4FF, #0099CC)', color: '#000', boxShadow: '0 0 15px rgba(0,212,255,0.3)' }}
            >
              <Icon name="Calendar" size={16} className="inline mr-2" />
              Book Consultation
            </button>
            <button
              onClick={onContact}
              className="px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200"
              style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)', color: '#00D4FF' }}
            >
              <Icon name="MessageCircle" size={16} className="inline mr-2" />
              Send Message
            </button>
            <a
              href={`tel:${professional?.phone}`}
              className="px-6 py-2.5 rounded-xl font-semibold text-sm transition-all duration-200 flex items-center gap-2"
              style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', color: '#A0B4C8' }}
            >
              <Icon name="Phone" size={16} />
              {professional?.phone}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHero;
